/* eslint eqeqeq: "off" */
import React from 'react';
import toastr from 'toastr';
import {findObjectByKey} from '../../util/index';


class ManageList extends React.Component {
	
	constructor(props, context) {
         
		super(props, context);	
		this.state = {			
			filtro:"",
			showModalBorrar:false,
            showModalActivar:false,
            activos:false,
			idBorrar:0	,
            idActivar:0,
            showActivos:true,
            cargaInfoFiltrosCombo:[]
             
		};
		
		
		this.borrar = this.borrar.bind(this);
		this.oncloseModal = this.oncloseModal.bind(this);
		this.handleSelectPagination = this.handleSelectPagination.bind(this);
		this.handleChangeFiltro = this.handleChangeFiltro.bind(this);
		this.onFiltrarInformacion = this.onFiltrarInformacion.bind(this);
		this.onDesactivarFiltro = this.onDesactivarFiltro.bind(this);
	}
	
   
	inicializa=()=>{	
        
        
        if(this.state.cargaInfoFiltrosCombo && this.state.cargaInfoFiltrosCombo.length>0){
             for(let i=0; i<this.state.cargaInfoFiltrosCombo.length; i++)
            this.state.cargaInfoFiltrosCombo[i]();
        }
        
        
         let filtrosCombo = this.state.filtrosCombo;
        let filtro = this.state.filtro;
        
        if(this.props.listado.filtrosCombo){
            filtrosCombo =  this.props.listado.filtrosCombo; 
        }        
        if(this.props.listado.filtroActual!=""){
            filtro=this.props.listado.filtroActual;
        }
        
        this.setState({"filtro": filtro});
        this.setState({"filtrosCombo": filtrosCombo});
        
		this.cargarInformacion(this.props.listado.paginaActual, this.props.listado.filtroActivo, this.props.listado.filtroActual, this.props.listado.showActivos, this.state.filtrosCombo);	
	}
	
	onShowModalBorrar=(idBorrar, event)=>{
		this.setState({"idBorrar": idBorrar});
		this.setState({"showModalBorrar": true});
		 
	}
    
    onShowModalActivar=(idActivar, event)=>{
        //debugger;
		this.setState({"idActivar": idActivar});
		this.setState({"showModalActivar": true});
		 
	}
	
	borrar(){
		this.oncloseModal();
		this.props.listadoActions.borrar(this.state.idBorrar, this.props.user).then(()=>{			
			toastr.success('Registro Borrado');
		})
        .catch(error=>{			
          toastr.error(error.responseJSON.message);
        });				
	}
	
    activar=()=>{
        //debugger;
		this.oncloseModal();
		this.props.listadoActions.activar(this.state.idActivar, this.props.user).then(()=>{			
			toastr.success('Estatus modificado');
		})
        .catch(error=>{			
          toastr.error(error.responseJSON.message);
        });				
	}

	oncloseModal(){
		this.setState({"showModalBorrar": false, "showModalActivar": false, "showModalDuplicar": false});		
	}


    handleChangeFiltroCombo=(event, data)=> {
        let filtrosCombo = this.state.filtrosCombo;
        let cargaInfoFiltrosCombo = this.state.cargaInfoFiltrosCombo;
        let field= data.name;		
        let value=	data.value;		
   
        
        filtrosCombo[field]= value;
		 
        if(data.options && data.options.length>0){
            let opcion=findObjectByKey(data.options, value);
            if(opcion){
                if(opcion.text.length>20){
                    filtrosCombo[field+"text"]= opcion.text.substring(0, 20)+"...";        
                    
                }else{
                    filtrosCombo[field+"text"]= opcion.text;        
                }
                filtrosCombo[field+"textCompleto"]= opcion.text;        
            }
            
        }
    
        //vemos si tiene asociada una funcion y la llamamos 
        for (var comboValue in cargaInfoFiltrosCombo) {
                  if(comboValue==field){
                      cargaInfoFiltrosCombo[comboValue](value);
                  } 
        }

        this.setState({"filtrosCombo": filtrosCombo});
        
         
    }
	
	handleChangeActivos=(event, data)=> {		      
        let value;
        
        if(data.toggle || data.slider){
            //es un check
            value=	data.checked;
            this.setState({"showActivos": value});
            let filtrosCombo=Object.assign({}, this.props.listado.filtrosCombo);
            this.props.listadoActions.setFiltro(this.props.listado.filtroActivo, this.props.listado.filtroActual, value , filtrosCombo);
            this.cargarInformacion(0, this.props.listado.filtroActivo, this.props.listado.filtroActual, value, filtrosCombo);
        }                		        
    }

	handleChangeFiltro(event) {		      
      let value=event.target.value;				 				
      this.setState({"filtro": value});
    }
	
	handleSelectPagination(eventKey, data) {	
            
		this.cargarInformacion(Number(data.activePage)-1, this.props.listado.filtroActivo, this.props.listado.filtroActual, this.props.listado.showActivos, this.state.filtrosCombo);			
    }
	
	onDesactivarFiltro(){
        let filtrosCombo=this.props.listado.filtrosCombo;
        
        for (var comboValue in filtrosCombo) {
                  filtrosCombo[comboValue]="";
        }
        
		this.props.listadoActions.setFiltro(false, {}, this.props.listado.showActivos, filtrosCombo);
		this.cargarInformacion(0, false, "", this.props.listado.showActivos, filtrosCombo);				
	}
	
	onFiltrarInformacion(){
        //console.log("onFiltrarInformacion");
        let filtroValido=true;
        let errors={};
        let filtrosCombo=this.state.filtrosCombo;
        //console.log("filtrosCombo");
        //console.log(filtrosCombo);
        //debugger;
        for (var comboValue in filtrosCombo) {
              if(filtrosCombo[comboValue]==""){
                  if(!filtrosCombo['opcional']){
                        filtroValido=false;
                        errors[comboValue]=true;
                 }          
              }
        }
        this.setState({errors});
        
        if(filtroValido==true){
		  if((this.state.filtro && this.state.filtro!="") || (filtrosCombo && Object.keys(filtrosCombo).length>0)){	
              
                     this.props.listadoActions.setFiltro(true, this.state.filtro, this.props.listado.showActivos, Object.assign({}, filtrosCombo));
                     this.cargarInformacion(0, true, this.state.filtro, this.props.listado.showActivos, filtrosCombo);						

            }else{
                toastr.error("Debes capturar el criterio de busqueda.");	
            }	
        }else{
            
            toastr.error("Debes seleccionar los criterio de busqueda.");	    
        }
        
	}
	
	cargarInformacion(pagina, filtroActivo=false, filtro="", showActivos, filtrosCombo){		
        
		if(filtroActivo==false){
			filtro="";
		}
        
		this.props.load(pagina, this.props.listado.registrosPorPagina, filtro, showActivos, filtrosCombo, this.props.user).then()
        .catch(error=>{
          toastr.error(error);
        });
	}
	

	render() {	
			
		return (
			<div className="right_col" role="main">
	
			<div className="row">	
						
			</div>
			</div>
			
		);
	}
}



export default ManageList;